export class UserStatsModel {
    constructor(stats) {
        this._stats = {
            followersCount: stats.followers_count,
            followingCount: stats.following_count,
            workoutsCount: stats.workouts_count,
            repeatsCount: stats.repeats_count,
            classesCount: stats.classes_count,
            level: stats.level,
        };
    }

    get stats() {
        return this._stats;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/UserStatsModel.js